import React from 'react';
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  IconButton,
  VStack,
  Text,
  useDisclosure,
} from '@chakra-ui/react';
import { FaQuestionCircle } from 'react-icons/fa';
import QuickHelpContent from './QuickHelpContent.tsx';
import { useTranslation } from 'react-i18next';

interface HelpPopoverProps {
  variant?: 'icon' | 'button';
  size?: 'sm' | 'md' | 'lg';
}

const HelpPopover: React.FC<HelpPopoverProps> = ({ 
  variant = 'icon',
  size = 'md' 
}) => {
  const { t } = useTranslation();
  const { isOpen, onOpen, onClose } = useDisclosure();

  return (
    <>
      <IconButton
        aria-label="Aide"
        icon={<FaQuestionCircle />}
        size={size}
        variant="ghost"
        colorScheme="purple"
        onClick={onOpen}
        bg="var(--gris-bleute)"
        color="var(--texte-clair)"
        border="1px solid rgba(139, 148, 179, 0.3)"
        _hover={{
          bg: 'rgba(138, 43, 226, 0.2)',
          transform: 'scale(1.1)',
          color: 'var(--bleu-electrique)',
          borderColor: 'var(--bleu-electrique)',
        }}
        transition="all 0.2s"
      />

      <Modal isOpen={isOpen} onClose={onClose} size="xl" isCentered>
        <ModalOverlay bg="rgba(0, 0, 0, 0.6)" />
        <ModalContent 
          bg="var(--gris-bleute)" 
          border="1px solid rgba(139, 148, 179, 0.3)"
          maxW={{ base: "95%", md: "600px" }}
          mx={4}
        >
          <ModalHeader color="var(--texte-clair)" pb={2}>
            <Text fontSize="lg" fontWeight="bold" textAlign="center">
              {t('howToPlay')}
            </Text>
          </ModalHeader>
          <ModalCloseButton color="var(--texte-clair)" />
          <ModalBody pb={6}>
            <QuickHelpContent />
          </ModalBody>
        </ModalContent>
      </Modal>
    </>
  );
};

export default HelpPopover;
